import { Component, OnInit, ViewChild } from '@angular/core';
import { GridBaseCase } from '../grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, ActionSheetController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { NativeService } from '../../../../service/native.service';
import { Base64 } from '@ionic-native/base64/ngx';
// import { AnyARecord } from 'dns';
declare var app;
declare var imageConversion;
declare var cordova: any;
@Component({
  selector: 'app-sfa-img-collection-camera',
  templateUrl: './sfa-img-collection-camera.component.html',
  styleUrls: ['./sfa-img-collection-camera.component.scss']
})
export class SfaImgCollectionCameraComponent extends GridBaseCase {

  dataArrayList: Array<any> = [];
  arrayPicture: Array<any> = [];
  submitArr = [];
  uploadLoading: boolean = false;//上传加载中
  uploadLoadingArr = [];
  product: any = null;
  mastId: any = null;
  isSuccess: boolean = false;
  isFail: any = null;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    private nativeservice: NativeService,
    private actionSheet: ActionSheetController,
    private base64: Base64
  ) {
    super();


  }

  LoadData(PageNumber) {
    let that = this;
    console.log("1001011");
    if (localStorage.getItem("bardage")) {
      that.isSuccess = false;
      that.isFail = localStorage.getItem("bardage");
      if (document.getElementsByName("save_camera_img")[0]) {
        document.getElementsByName("save_camera_img")[0].innerText = "重新提交";
      }
      localStorage.removeItem("bardage");
    }
    if (localStorage.getItem("bardagecount")) {
      that.isSuccess = true;
      that.isFail = null;
      console.log(document.getElementsByName("save_camera_img")[0]);
      if (document.getElementsByName("save_camera_img")[0]) {
        for (let index = 0; index < document.getElementsByName("save_camera_img").length; index++) {
          document.getElementsByName("save_camera_img")[index].style.display = "none";

        }
        //   document.getElementsByName("save_camera_img")[0].style.display="none";
      }
      localStorage.removeItem("bardagecount");
    }

    that.product = that.com.GetStorageKey("brand").Name;
    that.baseService.arrayData = [];
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';

    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split('&')[0];
    let body = new WebParameterContext();
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }
    // body.ConfigName="TBProductCheckMaster2XML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (!that.com.GetAccount.IsAdmin) {
      // console.log(that.month);
      // if (!that.searchDate) {
      //   let startDate = that.com.getNow.split('-')[0] + "-" + that.com.getNow.split('-')[1] + "-" + "01" + " 00:00:00";
      //   let endDate = that.com.getNow.split('-')[0] + "-" + that.com.getNow.split('-')[1] + "-" + (new Date().getDate()) + " 23:59:59";
      //   that.searchDate = that.com.BetweenDate(startDate, endDate);
      // }
      if (id) {
        body.RequestBody = JSON.stringify({ "a_FK_TBProductBrand_ID": id, "a_FK_SystemUser_ID": that.com.GetAccount.Id,"a_FK_TBStore_ID":that.com.GetStorageKey("tbstore").ID });
      }
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      let product: Array<any> = [];
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(function (item) {
          let objfield = {};
          that.element.selectItemList.selectItem.forEach((element, index) => {
            if (element.bindingField) {
              objfield[element.bindingField] = item[element.field];
            }
          });
          product.push(objfield);
          // that.baseService.arrayData.push(objfield);
        });
        //组装数据
        if (product.length > 0) {
          if (product[0].ID) {
            that.mastId = product[0].ID;
          }
          //组装照片
          if (product[0].old) {
            let arrayimg: Array<any> = product[0].old.split(',');
            arrayimg.forEach(item => {
              if (item) {
                let imgurl = {};
                if (that.mastId) {
                  imgurl["a_ID"] = that.mastId;
                }
                imgurl["a_PhotoBefore"] = item;
                imgurl["old"] = (app.UPLOADSmallImageURL + item).replace("placeholder/","");
                imgurl["a_FK_TBProductBrand_ID"] = id;
                imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
                imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
                that.baseService.arrayData.push(imgurl);
              }
            });
          }
        }

      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    })
  }

  async pictureEvent() {
    let that = this;
    const actionSheet = await that.actionSheet.create({
      buttons: [{
        text: '拍照',
        icon: 'camera',
        handler: () => {
          if (that.platform.is("cordova")) {
            if (that.platform.is("android")) {
              that.EventPicImg();
              // that.EventIosPicImg1();
            } else if (that.platform.is("ios") || that.platform.is("iphone") || that.platform.is("ipad")) {
              that.EventIosPicImg();
            }
          }
        }
      }, {
        text: '取消',
        icon: '',
        role: 'cancel',
        handler: () => {
        }
      }]
    });
    await actionSheet.present();
  }

  /**
   * 
   * @param imgArr 上传图片数组
   * @param index 上传的第几张
   */
  EventUploadMultipleImg(imgArr, index) {
    const img = imgArr[index];
    if(!img){return;}
    let that = this;
    const getID = this.activaRouter.snapshot.paramMap.get("id");
    let ut = {};
    ut["new"] = img;
    ut["old"] = img;
    //that.baseService.arrayData[pindex]['pic'].value.push(ut);
    that.base64.encodeFile(img).then((base64File: string) => {
        if(imgArr.length > (index+1)){
          that.EventUploadMultipleImg(imgArr,index+1);
        }
        imageConversion.dataURLtoFile(base64File, 'image/jpeg').then(file => {
            imageConversion.compressAccurately(file, 600).then(blob => {
              let formData = new FormData();
              formData.append('files', blob, new Date().getTime() + ".jpg");
              var request = new XMLHttpRequest();
              // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
              request.open('post', app.UPLOADURL, true);
              // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
              request.send(formData);
              request.onload = function (data) {
                that.uploadLoading = false;
                that.uploadLoadingArr.splice(0, 1);
                if (data.currentTarget['status'] == 200) {
                  const body = JSON.parse(data.currentTarget['response']);
                  if (body.ResponseMessage.Success) {
                    console.log("上传" + body);
                    // that.img_url[that.config.name] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
                    // that.group.controls[that.config.name].setValue(body.Status[0].FileName);
                    // that.ImageLoading(that.img_url[that.config.name]);
                    let imgurl = {};
                    imgurl["a_PhotoBefore"] = body.Status[0].FileName;
                    imgurl["old"] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
                    imgurl["a_FK_TBProductBrand_ID"] = getID;
                    imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
                    imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
                    that.baseService.arrayData.push(imgurl);
                    console.log(body);
                  } else {
                    that.msg.Alert(body.ResponseMessage.ErrorMessage);
                  }
                } else {
                  console.log(data);
                  that.msg.Alert("图片上传失败");
                }
              }
            })
        })
    }, (err) => {
      console.log(err);
    });
  }
  /**
   * 上传图片
   * @param pindex 产品品牌下标
   * @param index 图片下标,做数据预览时使用
   */
  EventPicImg() {
    const that = this;
    const getID = this.activaRouter.snapshot.paramMap.get("id");
    const arrayimgs: number = parseInt(that.element.max) || 0;
    if (that.baseService.arrayData.length > arrayimgs) {
      that.msg.Alert("最多上传" + arrayimgs + "张照片");
      return;
    }
    // let imgurl={};
    //     imgurl["a_PhotoBefore"]="[1903201431424010]1553063443535.jpg,[1903201431424010]1553063443535.jpg";
    //     imgurl["old"]=app.UPLOADREADURL + "[1903201431424010]1553063443535.jpg" + "&size=t";
    //     imgurl["a_FK_TBProductBrand_ID"]=getID;
    //     imgurl["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
    //     imgurl["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore").ID;
    // that.baseService.arrayData.push(imgurl);

    cordova.plugins.camera.tackCamera("AR拍照", function (data) {
      if (!data || data == 'null') {
        that.msg.Show("上传图片不能为空");
        return
      }
      const picnumber: number = that.baseService.arrayData.length;
      if (that.baseService.arrayData.length > arrayimgs) {
        that.msg.Alert("最多上传" + arrayimgs + "张照片");
        return;
      }
      console.log(data);
      let imgarray: any = data.replace('[', '').replace(']', '');
      let arrayimg: Array<any> = imgarray.split(',');
      if (picnumber + arrayimg.length > arrayimgs) {
        that.msg.Show("上传图片超过" + arrayimgs + "张");
        return;
      }
      
      // that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
      arrayimg.forEach((img) => {
        // (function (img) {
        //   let ut = {};
        //   ut["new"] = img;
        //   ut["old"] = img;
        //   //that.baseService.arrayData[pindex]['pic'].value.push(ut);
        //   that.uploadLoadingArr.push(ut);
        //   that.base64.encodeFile(img).then((base64File: string) => {
        //     (function (base64File) {
        //       imageConversion.dataURLtoFile(base64File, 'image/jpeg').then(file => {
        //         (function (file) {
        //           imageConversion.compressAccurately(file, 600).then(blob => {
        //             let formData = new FormData();
        //             formData.append('files', blob, new Date().getTime() + ".jpg");
        //             var request = new XMLHttpRequest();
        //             // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
        //             request.open('post', app.UPLOADURL, true);
        //             // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
        //             request.send(formData);
        //             request.onload = function (data) {
        //               that.uploadLoading = false;
        //               that.uploadLoadingArr.splice(0, 1);
        //               if (data.currentTarget['status'] == 200) {
        //                 const body = JSON.parse(data.currentTarget['response']);
        //                 if (body.ResponseMessage.Success) {
        //                   console.log("上传" + body);
        //                   // that.img_url[that.config.name] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
        //                   // that.group.controls[that.config.name].setValue(body.Status[0].FileName);
        //                   // that.ImageLoading(that.img_url[that.config.name]);
        //                   let imgurl = {};
        //                   imgurl["a_PhotoBefore"] = body.Status[0].FileName;
        //                   imgurl["old"] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
        //                   imgurl["a_FK_TBProductBrand_ID"] = getID;
        //                   imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
        //                   imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
        //                   that.baseService.arrayData.push(imgurl);
        //                   console.log(body);
        //                 } else {
        //                   that.msg.Alert(body.ResponseMessage.ErrorMessage);
        //                 }
        //               } else {
        //                 console.log(data);
        //                 that.msg.Alert("图片上传失败");
        //               }
        //             }
        //           })
        //         })(file)

        //       })
        //     })(base64File)

        //   }, (err) => {
        //     console.log(err);
        //   });
        // })(img)
        img="file://"+img;
        let imgtype:number=1;
        that.uploadLoadingArr.push(img);
     that.nativeservice.Base64File(img).then(data=>{
    that.nativeservice.CompressAccurately(data,1).then(imgdata=>{
      that.uploadLoadingArr.splice(0,1);
      let imgurl = {};
      if (that.mastId) {
        imgurl["a_ID"] = that.mastId;
      }
      imgurl["a_PhotoBefore"] = imgdata.Status[0].FileName;
      imgurl["old"] = (app.UPLOADSmallImageURL + imgdata.Status[0].FileName).replace("placeholder/","");
      imgurl["a_FK_TBProductBrand_ID"] = getID;
      imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
      imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
      that.baseService.arrayData.push(imgurl);
    }).catch(error=>{
      console.log(error);
    });
  }).catch(error=>{
    console.log(error);
  });
        // //上传照片
        // (function(img){
        //   that.uploadLoadingArr.push(img);
        //   that.nativeservice.UploadFile(img.trim()).then((imgdata) => {
        //     that.uploadLoadingArr.splice(0,1);
        //     if (imgdata.ResponseMessage.Success) {
        //       let imgurl = {};
        //       if (that.mastId) {
        //         imgurl["a_ID"] = that.mastId;
        //       }
        //       imgurl["a_PhotoBefore"] = imgdata.Status[0].FileName;
        //       imgurl["old"] = (app.UPLOADSmallImageURL + imgdata.Status[0].FileName).replace("placeholder/","");
        //       imgurl["a_FK_TBProductBrand_ID"] = getID;
        //       imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
        //       imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
        //       that.baseService.arrayData.push(imgurl);
        //     }
        //   });
        // })(img)
      });
      //上传第一张
      // if(that.arrayData.length>0){
      //   let imgdatas:Array<any>=[];
      //   that.arrayData.forEach((newimg)=>{
      //     imgdatas.push(newimg.new);
      //   });
      // that.group.controls[that.config.name].setValue(imgdatas.toString());
      // }
    }, function (msg) {
      console.log(msg);
    })

    // that.native.getCameraPicture().then((pic) => {
    //   let arrayimg: Array<any> = [];
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   console.log(arrayimg, "pic");
    //   // that.uploadNum = arrayimg;
    //   that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
    //   arrayimg.forEach((item, index) => {

    //     that.native.UploadPictures(pic).then(imgdata => {
    //       console.log(imgdata, "imgdata");
    //       let ut = {};
    //       if (imgdata.ResponseMessage.Success) {
    //         setTimeout(()=>{
    //           that.baseService.arrayData[pindex]['pic']["uploadNum"].splice(0,1);
    //         // console.log("上传" + body);
    //         ut["new"] = imgdata.Status[0].FileName;
    //         ut["old"] = app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=o";
    //         ut["pre"]= app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=t";
    //         that.baseService.arrayData[pindex]['pic'].value.push(ut);
    //       },2000);
    //       }
    //     })
    //   })

    // }).then(err => {
    //   that.msg.Alert("请在app中操作");
    // });
  }
  /**
 * 上传图片
 * @param pindex 产品品牌下标
 * @param index 图片下标,做数据预览时使用
 */
  EventIosPicImg() {
    const that = this;
    const getID = this.activaRouter.snapshot.paramMap.get("id");
    const arrayimgs: number = parseInt(that.element.max) || 0;
    if (that.baseService.arrayData.length > arrayimgs) {
      that.msg.Alert("最多上传" + arrayimgs + "张照片");
      return;
    }
    // let imgurl={};
    //     imgurl["a_PhotoBefore"]="[1903201431424010]1553063443535.jpg,[1903201431424010]1553063443535.jpg";
    //     imgurl["old"]=app.UPLOADREADURL + "[1903201431424010]1553063443535.jpg" + "&size=t";
    //     imgurl["a_FK_TBProductBrand_ID"]=getID;
    //     imgurl["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
    //     imgurl["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore").ID;
    // that.baseService.arrayData.push(imgurl);

    cordova.plugins.cameralib.coolMethod("AR拍照", function (data) {
      if (!data || data == 'null') {
        that.msg.Show("上传图片不能为空");
        return
      }
      const picnumber: number = that.baseService.arrayData.length;
      if (that.baseService.arrayData.length > arrayimgs) {
        that.msg.Alert("最多上传" + arrayimgs + "张照片");
        return;
      }
      console.log(data);
      let imgarray: any = data.replace('[', '').replace(']', '').replace(/,$/,"");
      let arrayimg: Array<any> = imgarray.split(',');
      if (picnumber + arrayimg.length > arrayimgs) {
        that.msg.Show("上传图片超过" + arrayimgs + "张");
        return;
      }
      // that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
      arrayimg.forEach((img) => {
        (function (img) { 
          that.uploadLoadingArr.push(img);
          that.nativeservice.UploadFile(img.trim()).then((imgdata) => {
            that.uploadLoadingArr.splice(0,1);
            if (imgdata.ResponseMessage.Success) {
              let imgurl = {};
              imgurl["a_PhotoBefore"] = imgdata.Status[0].FileName;
              imgurl["old"] = (app.UPLOADSmallImageURL + imgdata.Status[0].FileName).replace("placeholder/","");
              imgurl["a_FK_TBProductBrand_ID"] = getID;
              imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
              imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
              that.baseService.arrayData.push(imgurl);
            }
          });
        })(img);

        // (function (img) {
        //   let ut = {};
        //   ut["new"] = img;
        //   ut["old"] = img;
        //   //that.baseService.arrayData[pindex]['pic'].value.push(ut);
        //   that.uploadLoadingArr.push(ut);
        //   that.base64.encodeFile(img).then((base64File: string) => {
        //     imageConversion.dataURLtoFile(base64File, 'image/jpeg').then(file => {
        //       imageConversion.compressAccurately(file, 600).then(blob => {
        //         let formData = new FormData();
        //         formData.append('files', blob, new Date().getTime() + ".jpg");
        //         var request = new XMLHttpRequest();
        //         // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
        //         request.open('post', app.UPLOADURL, true);
        //         // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
        //         request.send(formData);
        //         request.onload = function (data) {
        //           that.uploadLoading = false;
        //           that.uploadLoadingArr.splice(0, 1);
        //           if (data.currentTarget['status'] == 200) {
        //             const body = JSON.parse(data.currentTarget['response']);
        //             if (body.ResponseMessage.Success) {
        //               console.log("上传" + body);
        //               // that.img_url[that.config.name] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
        //               // that.group.controls[that.config.name].setValue(body.Status[0].FileName);
        //               // that.ImageLoading(that.img_url[that.config.name]);
        //               let imgurl = {};
        //               imgurl["a_PhotoBefore"] = body.Status[0].FileName;
        //               imgurl["old"] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
        //               imgurl["a_FK_TBProductBrand_ID"] = getID;
        //               imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
        //               imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
        //               that.baseService.arrayData.push(imgurl);
        //               console.log(body);
        //             } else {
        //               that.msg.Alert(body.ResponseMessage.ErrorMessage);
        //             }
        //           } else {
        //             console.log(data);
        //             that.msg.Alert("图片上传失败");
        //           }
        //         }
        //       })
        //     })
        //   }, (err) => {
        //     console.log(err);
        //   });

        //   //上传照片
        // })(img)



      });
      // if(that.arrayData.length>0){
      //   let imgdatas:Array<any>=[];
      //   that.arrayData.forEach((newimg)=>{
      //     imgdatas.push(newimg.new);
      //   });
      // that.group.controls[that.config.name].setValue(imgdatas.toString());
      // }
    }, function (msg) {
      console.log(msg);
    })

    // that.native.getCameraPicture().then((pic) => {
    //   let arrayimg: Array<any> = [];
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   console.log(arrayimg, "pic");
    //   // that.uploadNum = arrayimg;
    //   that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
    //   arrayimg.forEach((item, index) => {

    //     that.native.UploadPictures(pic).then(imgdata => {
    //       console.log(imgdata, "imgdata");
    //       let ut = {};
    //       if (imgdata.ResponseMessage.Success) {
    //         setTimeout(()=>{
    //           that.baseService.arrayData[pindex]['pic']["uploadNum"].splice(0,1);
    //         // console.log("上传" + body);
    //         ut["new"] = imgdata.Status[0].FileName;
    //         ut["old"] = app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=o";
    //         ut["pre"]= app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=t";
    //         that.baseService.arrayData[pindex]['pic'].value.push(ut);
    //       },2000);
    //       }
    //     })
    //   })

    // }).then(err => {
    //   that.msg.Alert("请在app中操作");
    // });
  }


  EventIosPicImg1() {
    const that = this;
    const getID = this.activaRouter.snapshot.paramMap.get("id");
    const arrayimgs: number = parseInt(that.element.max) || 0;
    if (that.baseService.arrayData.length > arrayimgs) {
      that.msg.Alert("最多上传" + arrayimgs + "张照片");
      return;
    }
    // let imgurl={};
    //     imgurl["a_PhotoBefore"]="[1903201431424010]1553063443535.jpg,[1903201431424010]1553063443535.jpg";
    //     imgurl["old"]=app.UPLOADREADURL + "[1903201431424010]1553063443535.jpg" + "&size=t";
    //     imgurl["a_FK_TBProductBrand_ID"]=getID;
    //     imgurl["a_FK_SystemUser_ID"]=that.com.GetAccount.Id;
    //     imgurl["a_FK_TBStore_ID"]=that.com.GetStorageKey("tbstore").ID;
    // that.baseService.arrayData.push(imgurl);
    const data: any = "[/storage/emulated/0/Android/data/com.baozi.nestle4goods_photomoudel/cache/hgz/1541140468470/1557575154752.jpg,/storage/emulated/0/Android/data/com.baozi.nestle4goods_photomoudel/cache/hgz/1541140468470/1557575156146.jpg]";
    if (!data || data == 'null') {
      that.msg.Show("上传图片不能为空");
      return
    }
    const picnumber: number = that.baseService.arrayData.length;
    if (that.baseService.arrayData.length > arrayimgs) {
      that.msg.Alert("最多上传" + arrayimgs + "张照片");
      return;
    }
    console.log(data);
    let imgarray: any = data.replace('[', '').replace(']', '').replace(/,$/,"");
    let arrayimg: Array<any> = imgarray.split(',');
    if (picnumber + arrayimg.length > arrayimgs) {
      that.msg.Show("上传图片超过" + arrayimgs + "张");
      return;
    }
    // that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
    console.log(arrayimg);
    arrayimg.forEach((img) => {
      (function (img) {
        let ut = {};
        console.log(img, "img");
        ut["new"] = img;
        ut["old"] = img;
        //that.baseService.arrayData[pindex]['pic'].value.push(ut);
        that.uploadLoadingArr.push(ut);
        that.base64.encodeFile(img).then((base64File: string) => {
          console.log(base64File.split(',')[0].match(/:(.*?);/));
          imageConversion.dataURLtoFile(base64File, 'image/jpeg').then(file => {
            imageConversion.compressAccurately(file, 600).then(blob => {
              let formData = new FormData();
              formData.append('files', blob, new Date().getTime() + ".jpg");
              console.log(blob, "blob");
              return;
              var request = new XMLHttpRequest();
              // request.setRequestHeader("Content-Type","multipart/form-data; charset=UTF-8");
              request.open('post', app.UPLOADURL, true);
              // request.setRequestHeader('Authorization',"Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiU0EiLCJJRCI6ImIxYTAzYjMzLThjOGEtNDZjYS04MDRjLTE2NmJmNWIxNDY5YSIsIkRpc3BsYXlOYW1lIjoi6ZSA5ZSu5Luj6KGoIiwiTG9naW5OYW1lIjoiU0EiLCJBcHAiOiJ0cnVlIiwianRpIjoiYjFhMDNiMzMtOGM4YS00NmNhLTgwNGMtMTY2YmY1YjE0NjlhIiwiaWF0IjoiMjAxOS80LzE4IDI6NDU6MjMiLCJuYmYiOjE1NTU1NTU1MjMsImV4cCI6MTU1NTY0MTkyMywiaXNzIjoiaHR0cDovL3d3dy5tb2Jpem9uZS5jbiIsImF1ZCI6Ind3dy5tb2Jpem9uZS5jbiJ9.yGhPdG_90bdr8o8WDjneYdvQ6B4ysk_22Yxw8ZETHFg");
              request.send(formData);
              request.onload = function (data) {
                that.uploadLoading = false;
                that.uploadLoadingArr.splice(0, 1);
                if (data.currentTarget['status'] == 200) {
                  const body = JSON.parse(data.currentTarget['response']);
                  if (body.ResponseMessage.Success) {
                    console.log("上传" + body);
                    // that.img_url[that.config.name] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
                    // that.group.controls[that.config.name].setValue(body.Status[0].FileName);
                    // that.ImageLoading(that.img_url[that.config.name]);
                    let imgurl = {};
                    imgurl["a_PhotoBefore"] = body.Status[0].FileName;
                    imgurl["old"] = app.UPLOADREADURL + body.Status[0].FileName + "&size=t";
                    imgurl["a_FK_TBProductBrand_ID"] = getID;
                    imgurl["a_FK_SystemUser_ID"] = that.com.GetAccount.Id;
                    imgurl["a_FK_TBStore_ID"] = that.com.GetStorageKey("tbstore").ID;
                    that.baseService.arrayData.push(imgurl);
                    console.log(body);
                  } else {
                    that.msg.Alert(body.ResponseMessage.ErrorMessage);
                  }
                } else {
                  console.log(data);
                  that.msg.Alert("图片上传失败");
                }
              }
            })
          })
        }, (err) => {
          console.log(err);
        });
        //上传照片
      })(img)



    });
    // if(that.arrayData.length>0){
    //   let imgdatas:Array<any>=[];
    //   that.arrayData.forEach((newimg)=>{
    //     imgdatas.push(newimg.new);
    //   });
    // that.group.controls[that.config.name].setValue(imgdatas.toString());
    // }

    // that.native.getCameraPicture().then((pic) => {
    //   let arrayimg: Array<any> = [];
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   arrayimg.push(pic);
    //   console.log(arrayimg, "pic");
    //   // that.uploadNum = arrayimg;
    //   that.baseService.arrayData[pindex]['pic']["uploadNum"] = arrayimg;
    //   arrayimg.forEach((item, index) => {

    //     that.native.UploadPictures(pic).then(imgdata => {
    //       console.log(imgdata, "imgdata");
    //       let ut = {};
    //       if (imgdata.ResponseMessage.Success) {
    //         setTimeout(()=>{
    //           that.baseService.arrayData[pindex]['pic']["uploadNum"].splice(0,1);
    //         // console.log("上传" + body);
    //         ut["new"] = imgdata.Status[0].FileName;
    //         ut["old"] = app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=o";
    //         ut["pre"]= app.UPLOADREADURL + imgdata.Status[0].FileName + "&size=t";
    //         that.baseService.arrayData[pindex]['pic'].value.push(ut);
    //       },2000);
    //       }
    //     })
    //   })

    // }).then(err => {
    //   that.msg.Alert("请在app中操作");
    // });
  }


  ImgPreview(index) {
    let that = this;
    const url = [];
    that.baseService.arrayData.forEach(item => {
      url.push(item.old.trim().replace("thumbnails","images"));
    });
    let ImgPreview = {
      imgUrl: url,
      index: index
    }
    // localStorage.setItem("ImgPreview",JSON.stringify(ImgPreview));
    // that.router.navigate(["/tabs/contact/ImgPreview"]);
    // that.router.navigate(["/tabs/contact/ImgPreview"], {
    //   queryParams: {
    //     ImgPreview: JSON.stringify(ImgPreview)
    //   }
    // });
    that.com.Go("/tabs/contact/ImgPreview",{
      ImgPreview: JSON.stringify(ImgPreview)
    })
  }

  async EditImg(index: number) {
    const that = this;
    const pageType = that.activaRouter.snapshot.paramMap.get('type');
    if(pageType=="view"){
      that.ImgPreview(index);
      return;
    }
    const actionSheet = await this.actionSheet.create({
      // header: '',
      buttons: [{
        text: '预览',
        handler: () => {
          that.ImgPreview(index);
        }
      }, {
        text: '删除',
        handler: () => {
          that.baseService.arrayData.splice(index, 1);
          // let _obj = null;
          // let _newobj = null;
          // let templateName = that.template.name;
          // let Name = that.config.name;
          // that.group.removeControl[that.config.name];
          // that.img_url[that.config.name] = null;
          // _obj = localStorage.getItem(templateName);
          // if (_obj) {
          //   _newobj = JSON.parse(localStorage.getItem(templateName)) || {};
          //   delete _newobj[Name];
          // }
          // localStorage.setItem(templateName, JSON.stringify(_newobj));
        }
      }, {
        text: '取消',
        role: 'cancel',
        handler: () => {
          console.log('Cancel clicked');
        }
      }]
    });
    await actionSheet.present();
  }


}
